import { openBlock as t, createElementBlock as e, createElementVNode as l } from "vue";
const r = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function c(o, a) {
  return t(), e("svg", r, [...a[0] || (a[0] = [
    l("g", { "clip-path": "url(#a)" }, [
      l("path", {
        fill: "currentColor",
        d: "M18.877 12.882c.037-.288.064-.576.064-.882s-.027-.594-.064-.882l1.952-1.485a.446.446 0 0 0 .11-.576l-1.85-3.114a.47.47 0 0 0-.407-.225.4.4 0 0 0-.157.027l-2.304.9a6.8 6.8 0 0 0-1.563-.882l-.352-2.385A.45.45 0 0 0 13.853 3h-3.701a.45.45 0 0 0-.454.378l-.351 2.385a7.2 7.2 0 0 0-1.564.882l-2.304-.9a.5.5 0 0 0-.167-.027.46.46 0 0 0-.397.225l-1.85 3.114a.436.436 0 0 0 .11.576l1.952 1.485a7 7 0 0 0-.064.882c0 .297.027.594.064.882l-1.952 1.485a.446.446 0 0 0-.11.576l1.85 3.114c.083.144.24.225.407.225a.4.4 0 0 0 .157-.027l2.304-.9c.481.36 1 .657 1.564.882l.351 2.385a.45.45 0 0 0 .454.378h3.7a.45.45 0 0 0 .454-.378l.352-2.385a7.2 7.2 0 0 0 1.563-.882l2.304.9a.5.5 0 0 0 .167.027.46.46 0 0 0 .397-.225l1.85-3.114a.446.446 0 0 0-.11-.576zm-1.832-1.539c.037.279.046.468.046.657s-.019.387-.046.657l-.13 1.017.824.63.999.756-.648 1.089-1.175-.459-.962-.378-.833.612a5.5 5.5 0 0 1-1.156.657l-.981.387-.148 1.017-.185 1.215h-1.296l-.175-1.215-.149-1.017-.98-.387a5.3 5.3 0 0 1-1.138-.639l-.842-.63-.981.387-1.175.459-.648-1.089 1-.756.823-.63-.13-1.017A7 7 0 0 1 6.913 12c0-.18.019-.387.046-.657l.13-1.017-.823-.63-1-.756.648-1.089 1.175.459.962.378.833-.612a5.5 5.5 0 0 1 1.156-.657l.981-.387.148-1.017.185-1.215h1.287l.175 1.215.148 1.017.981.387a5.3 5.3 0 0 1 1.138.639l.842.63.98-.387 1.176-.459.648 1.089-.99.765-.824.63zM12.002 8.4c-2.045 0-3.701 1.611-3.701 3.6s1.656 3.6 3.701 3.6 3.701-1.611 3.701-3.6-1.656-3.6-3.701-3.6m0 5.4c-1.018 0-1.85-.81-1.85-1.8s.832-1.8 1.85-1.8 1.85.81 1.85 1.8-.832 1.8-1.85 1.8"
      })
    ], -1),
    l("defs", null, [
      l("clipPath", { id: "a" }, [
        l("path", {
          fill: "currentColor",
          d: "M0 0h24v24H0z"
        })
      ])
    ], -1)
  ])]);
}
const s = { render: c };
export {
  s as default,
  c as render
};
